import { useState } from "react";
import { Button } from "@mantine/core";
import DatePicker from "src/components/DatePicker";
import { useUpdateSignedAgreementMutation } from "src/generated/graphql";
import { useModals } from "@mantine/modals";

interface IPaymentProps {
  signedAgreementId: string;
  expiresAt?: Date;
  onRefetch: () => void;
}
const Expiry = ({ signedAgreementId, expiresAt, onRefetch }: IPaymentProps) => {
  const modals = useModals();
  const [expiryValue, setExpiryValue] = useState<Date>(expiresAt || new Date());

  const [updateAgreement, { loading }] = useUpdateSignedAgreementMutation({
    onCompleted: () => {
      onRefetch();
      modals.closeAll();
    },
  });
  const updateSignedAgreementPaymentMethod = () => {
    expiryValue &&
      updateAgreement({
        variables: {
          id: signedAgreementId,
          data: {
            termEnd: expiryValue,
          },
        },
      });
  };

  const handleStartAt = (date: Date) => {
    setExpiryValue(date);
  };

  return (
    <>
      <DatePicker
        label="Expiry"
        mx="auto"
        value={expiryValue}
        onChange={handleStartAt}
      />

      <Button
        size={"xs"}
        mt={20}
        disabled={loading}
        onClick={() => expiryValue && updateSignedAgreementPaymentMethod()}
      >
        Save
      </Button>
    </>
  );
};

export default Expiry;
